module.exports = "pegasus/assets/hexagon-instagram.png";